import { copyText, type CopyKind } from './releaseFormsData'

/** Copies to the clipboard and says so (OnlyFans' copy helper and its toasts). */
export async function copyToClipboard(kind: CopyKind, v: Parameters<typeof copyText>[1], say: (text: string) => void, t: (k: string) => string) {
  const { text, toast } = copyText(kind, v)
  try {
    if (!navigator.clipboard?.writeText) throw new Error('no clipboard')
    await navigator.clipboard.writeText(text)
    say(t(toast))
  } catch {
    const input = document.createElement('input')
    input.style.cssText = 'position:fixed;left:-9999px;opacity:0;pointer-events:none;'
    input.value = text
    document.body.appendChild(input)
    try {
      input.select()
      say(t(document.execCommand('copy') ? toast : 'toast.copyFailed'))
    } catch {
      say(t('toast.copyFailed'))
    } finally {
      input.remove()
    }
  }
}
